import * as BX from 'main.core';
import { Event } from 'main.core';

import VanillaLazyLoad from "vanilla-lazyload";
import { Reflection } from "main.core";

const namespace = Reflection.namespace('BX.Citrus.Arealty')

let instance;

export class LazyLoad {
    constructor(options = {}) {
        instance = this;

        this.lazyLoad = new VanillaLazyLoad(Object.assign({},
            {
                class_applied: "lz-applied",
                class_loading: "lz-loading",
                class_loaded: "lz-loaded",
                class_error: "lz-error",
                callback_error: element => {
                    element.src = "https://via.placeholder.com/220x280/?text=Error";
                }
            },
            options
        ));

        Event.ready(() => this.lazyLoad.update());
        BX.addCustomEvent('onFrameDataReceived', (blocks, fromCache) => this.lazyLoad.update());
    }

    static getInstance() {
        return instance;
    }

    static initialize(options = {}) {
        if (!instance) {
            instance = new LazyLoad(options);
        }
        return instance;
    }
}

namespace.LazyLoad = LazyLoad;

